import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getSubscriptions = (dateRange = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/subscriptions`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const getSubscriptionPlansList = () =>
  axiosInstance.get(`${ADMIN_API_URL}/subscription_planes_list`, {
    headers: authHeaders(),
  });

export const deleteSubscription = (subscriptionId) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/subscriptions/delete/${subscriptionId}`,
    {},
    { headers: authHeaders() },
  );

export const createUserSubscription = (userId, payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/users/${userId}/subscribe`, payload, {
    headers: authHeaders(),
  });

export const updateUserSubscription = (subscriptionId, payload) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/subscriptions/${subscriptionId}/update`,
    payload,
    { headers: authHeaders() },
  );
